var _path, _rect, _path2, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8048 10.1953L10.7476 9.13807L13.2144 8.78567L12.862 11.2525L11.8048 10.1953Z",
    stroke: "#526069",
    strokeWidth: 1.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60352,
    y: 12.868,
    width: 0.666667,
    height: 4.5124,
    transform: "rotate(-135 9.60352 12.868)",
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667H2V2H11.3333V6.66667",
    stroke: "#526069",
    strokeWidth: 1.33333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 4.33333,
    width: 4,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 6.99996,
    width: 2,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33333,
    y: 9.66671,
    width: 2.66667,
    height: 0.666667,
    className: "iconStrokeAndFill",
    strokeWidth: 0.666667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLicense);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjgwNDggMTAuMTk1M0wxMC43NDc2IDkuMTM4MDdMMTMuMjE0NCA4Ljc4NTY3TDEyLjg2MiAxMS4yNTI1TDExLjgwNDggMTAuMTk1M1oiIHN0cm9rZT0iIzUyNjA2OSIgc3Ryb2tlLXdpZHRoPSIxLjMzMzMzIi8+CjxyZWN0IHg9IjkuNjAzNTIiIHk9IjEyLjg2OCIgd2lkdGg9IjAuNjY2NjY3IiBoZWlnaHQ9IjQuNTEyNCIgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSA5LjYwMzUyIDEyLjg2OCkiIGNsYXNzPSJpY29uU3Ryb2tlQW5kRmlsbCIgc3Ryb2tlLXdpZHRoPSIwLjY2NjY2NyIvPgo8cGF0aCBkPSJNOCAxMi42NjY3SDJWMkgxMS4zMzMzVjYuNjY2NjciIHN0cm9rZT0iIzUyNjA2OSIgc3Ryb2tlLXdpZHRoPSIxLjMzMzMzIi8+CjxyZWN0IHg9IjQuMzMzMzMiIHk9IjQuMzMzMzMiIHdpZHRoPSI0IiBoZWlnaHQ9IjAuNjY2NjY3IiBjbGFzcz0iaWNvblN0cm9rZUFuZEZpbGwiIHN0cm9rZS13aWR0aD0iMC42NjY2NjciLz4KPHJlY3QgeD0iNC4zMzMzMyIgeT0iNi45OTk5NiIgd2lkdGg9IjIiIGhlaWdodD0iMC42NjY2NjciIGNsYXNzPSJpY29uU3Ryb2tlQW5kRmlsbCIgc3Ryb2tlLXdpZHRoPSIwLjY2NjY2NyIvPgo8cmVjdCB4PSI0LjMzMzMzIiB5PSI5LjY2NjcxIiB3aWR0aD0iMi42NjY2NyIgaGVpZ2h0PSIwLjY2NjY2NyIgY2xhc3M9Imljb25TdHJva2VBbmRGaWxsIiBzdHJva2Utd2lkdGg9IjAuNjY2NjY3Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };